import React from "react";
import { Col, Row, Typography } from "antd";
import { NavLink, useLocation } from "react-router-dom";

const { Paragraph } = Typography;

const WikiArticle = (props) => {
  const { Number, Title, Description, Id } = props;

  const { pathname, search } = useLocation();

  return (
    <Row className="word-rows">
      <Col span={24}>
        <NavLink
          to={{
            pathname: `/wiki/contents/${Id}`,
            state: { prevPath: pathname + search },
          }}
        >
          <div className="text-wrapper-title">
            <div className="text-number">{Number}</div>
            <Paragraph ellipsis className="text-title">
              {Title}
            </Paragraph>
            {/* <div className="visit-count">
              <div className="count-title">بازدید:</div>
              <div className="count-text">{VisitCount}</div>
            </div> */}
          </div>
          <Paragraph ellipsis className="text-wrapper-description">
            {Description}
          </Paragraph>
        </NavLink>
      </Col>
    </Row>
  );
};

export default WikiArticle;
